import {
    ContentfulEntryContract,
    ContentfulEntryContractFields,
    ContentfulEntryFromContract,
} from './contracts';

export type SupportedDeviceType = 'android' | 'headset' | 'ios';

export interface SupportedDeviceContentFields
    extends ContentfulEntryContractFields {
    names?: string[];
    title?: string;
    type?: SupportedDeviceType;
}

export type SupportedDeviceContract = ContentfulEntryContract<
    SupportedDeviceContentFields,
    'supportedDevice'
>;

export type SupportedDeviceContent =
    ContentfulEntryFromContract<SupportedDeviceContract>;

export class SupportedDevice {
    private contract: Partial<SupportedDeviceContent>;

    constructor(contract: Partial<SupportedDeviceContent> = {}) {
        this.contract = contract;
    }

    get names(): string[] {
        return this.contract.fields?.names ?? [];
    }

    get title(): string {
        return this.contract.fields?.title ?? '';
    }

    get type(): SupportedDeviceType | '' {
        return this.contract.fields?.type ?? '';
    }
}
